import { createColumnHelper } from "@tanstack/react-table";

const columnHelper = createColumnHelper();

export const orderTableColumnsConfig = (
  handleOpenModal,
  handleOrderDetails,
) => [
  columnHelper.accessor("order_id", {
    header: "Order Id",
    cell: (info) => info.getValue(),
  }),

  columnHelper.accessor("total_amount", {
    header: "Total Amt",
    cell: (info) => info.getValue(),
  }),

  columnHelper.accessor("num_of_items", {
    header: "No. of Items",
    cell: (info) => info.getValue(),
  }),

  columnHelper.accessor("area", {
    header: "Area",
    cell: (info) => info.getValue(),
  }),

  columnHelper.accessor("ordered_on", {
    header: "Date",
    cell: (info) => {
      const timestamp = info.getValue();
      const date = new Date(timestamp * 1000);

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = String(date.getFullYear()).slice(2);

      return `${day}/${month}/${year}`;
    },
  }),

  /* View Details */
  columnHelper.display({
    id: "view_details",
    header: "View Details",
    cell: (props) => (
      <button
        onClick={() => handleOrderDetails(props.row.original.id)}
        style={{
          padding: "6px 12px",

          background:
            "linear-gradient(135deg, #2F3567 0%, #5561A0 100%)",

          color: "#FFFFFF",

          border: "none",
          borderRadius: "6px",

          fontWeight: 500,
          fontSize: "13px",

          cursor: "pointer",

          transition: "all 0.18s ease",

          boxShadow: "0 2px 6px rgba(47,53,103,0.3)",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(135deg, #5561A0 0%, #7B82C0 100%)";
          e.currentTarget.style.boxShadow =
            "0 4px 12px rgba(47,53,103,0.35)";
          e.currentTarget.style.transform = "translateY(-1px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(135deg, #2F3567 0%, #5561A0 100%)";
          e.currentTarget.style.boxShadow =
            "0 2px 6px rgba(47,53,103,0.3)";
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        View Details
      </button>
    ),
  }),
];